import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    ref: "searchExpand",
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.expand ? 'search' : null
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.where,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    class: _vm.expand ? null : 'fold'
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "紧急状态",
      "prop": "emergency"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择紧急状态"
    },
    model: {
      value: _vm.where.emergency,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "emergency", $$v);
      },
      expression: "where.emergency"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("常规")]), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("紧急")]), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("重要")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "启停状态",
      "prop": "status"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择启停状态"
    },
    model: {
      value: _vm.where.status,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "status", $$v);
      },
      expression: "where.status"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('a-select-option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")]), _c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公告分类",
      "prop": "cateId"
    }
  }, [_c('a-select', {
    ref: "select",
    attrs: {
      "placeholder": "请选择公告分类"
    },
    model: {
      value: _vm.where.cateId,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "cateId", $$v);
      },
      expression: "where.cateId"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _vm._l(_vm.cateList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.cateId
      }
    }, [_vm._v(" " + _vm._s(item.cateName) + " ")]);
  })], 2)], 1)], 1)], 1), _vm.expand ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "发布日期",
      "prop": "startAndEndTime"
    }
  }, [_c('a-range-picker', {
    model: {
      value: _vm.where.startAndEndTime,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "startAndEndTime", $$v);
      },
      expression: "where.startAndEndTime"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "prop": "title",
      "label": "搜索"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入公告标题、拟稿人姓名"
    },
    model: {
      value: _vm.where.title,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "title", $$v);
      },
      expression: "where.title"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.fetch({
          current: 1,
          pageSize: 10
        });
      }
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.searchFrom.resetFields();
      }
    }
  }, [_vm._v("重置")]), _c('a', {
    style: {
      marginLeft: '5px',
      fontSize: '12px'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(" " + _vm._s(_vm.expand ? '收起' : '展开') + " "), _c('a-icon', {
    attrs: {
      "type": _vm.expand ? 'up' : 'down'
    }
  })], 1)], 1)])], 1)]), _c('a-card', {
    attrs: {
      "title": "列表",
      "size": "small",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "table-card-view",
    attrs: {
      "size": "middle",
      "row-key": function rowKey(row) {
        return row.id;
      },
      "columns": _vm.columns,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "data-source": _vm.data,
      "bordered": "",
      "scroll": {
        y: 500
      }
    },
    on: {
      "change": _vm.onChange
    },
    scopedSlots: _vm._u([{
      key: "releaseTemp",
      fn: function fn(text, row) {
        return [_c('div', {
          staticClass: "text-ellipsis",
          attrs: {
            "title": "".concat(row.releaseUser, "(").concat(row.organName, "/").concat(row.postName, ")")
          }
        }, [_vm._v(" " + _vm._s(row.releaseUser) + " (" + _vm._s(row.organName) + " / " + _vm._s(row.postName) + ") ")])];
      }
    }, {
      key: "emergency",
      fn: function fn(text, row) {
        return [1 === row.emergency ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("常规")]) : _vm._e(), 2 === row.emergency ? _c('a-tag', {
          staticClass: "tag-red"
        }, [_vm._v("紧急")]) : _vm._e(), 3 === row.emergency ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("重要")]) : _vm._e()];
      }
    }, {
      key: "noticeStatus",
      fn: function fn(text, row) {
        return [0 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("草　稿")]) : _vm._e(), 1 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待审核")]) : _vm._e(), 2 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("通　过")]) : _vm._e(), 3 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-red"
        }, [_vm._v("不通过")]) : _vm._e(), 4 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("撤　回")]) : _vm._e(), 5 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-purple"
        }, [_vm._v("已发布")]) : _vm._e(), 6 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-shallow-orange"
        }, [_vm._v("审核中")]) : _vm._e()];
      }
    }, {
      key: "status",
      fn: function fn(text, row) {
        return [_c('a-switch', {
          attrs: {
            "disabled": row.disabled,
            "checked": 1 === row.status,
            "loading": _vm.loading,
            "checked-children": "启用",
            "un-checked-children": "停用"
          },
          on: {
            "click": function click($event) {
              return _vm.enabling(row);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function fn(text, row) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), !row.disabledCon ? _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewDetail(row);
            }
          }
        }, [_vm._v("查看")])], 1), _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewSituation(row);
            }
          }
        }, [_vm._v("查阅情况")])], 1)], 1) : _vm._e()], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };